<template>
	<div>
		<p>باسلام و عرض ادب. شرکت پیام بار آسمان آسیا در راستا تکمیل نمایندگی های خود از افرادی که دارای شرایط همکاری هستند دعوت بعمل می آورد. علاقه مندان می توانند با تکمیل فرم زیر درخواست خود را جهت بررسی کارشناسان شرکت ارسال نمایند. از شما خواهشمندیم موارد ذیل رابا دقت تکمیل نمایید. "با تشکر روابط عمومی شرکت پیام بار آسمان آسیا"</p>
	</div>
	<div class="tab" data-name="personalInfo" data-type="form">
		<h3>فرم اطلاعات فردی</h3>
		<p>[ این فرم مربوط به اطلاعات فردی شما می باشد ]</p>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="firstName">نام</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="firstName"
					   id="firstName"
					   data-pattern="checkEmpty" />
				<label id="firstName" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="lastName">نام خانوادگی</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   data-pattern="checkEmpty"
					   name="lastName"
					   id="lastName" />
				<label id="lastName" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="id">شماره شناسنامه</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="id"
					   id="id"
					   data-pattern="checkEmpty" />
				<label id="id" class="error"></label>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="code">کدملی</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="NationalCode"
					   id="code"
					   data-pattern="checkEmpty" />
				<label id="code" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="place">محل صدور</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="place"
					   id="place"
					   data-pattern="checkEmpty" />
				<label id="place" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="local">محل تولد</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="local"
					   id="local"
					   data-pattern="checkEmpty" />
				<label id="local" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="birthday">تاریخ تولد</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="birthday"
					   id="birhtday"
					   data-pattern="checkEmpty" />
				<label id="birthday" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="fName">نام پدر</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="fName"
					   id="fName"
					   data-pattern="checkEmpty" />
				<label id="fName" class="error"></label>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 col-md-4">
				<label for="fJob">شغل پدر</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control"
					   @change="change"
					   name="fJob"
					   id="fJob"
					   data-pattern="checkEmpty" />
				<label id="fJob" class="error"></label>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},
      

		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		}
	};
</script>
